export default function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  const a = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-2xl ${a}`}>
      {eyebrow && (
        <span className="inline-block text-xs font-bold tracking-[0.15em] text-accent uppercase">
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-primary text-balance">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 text-base text-muted-foreground leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
}
